import axiosInstance from "./axiosInstance";

const StrategiesAPI = {
  getStrategy: () => {
    try {
      return axiosInstance.get("/strategy.json");
    } catch (error) {
      console.error("ContactAPI.getStrategy", error);
      return null;
    }
  },
  getStrategyEn: () => {
    try {
      return axiosInstance.get("/en/strategy.json");
    } catch (error) {
      console.error("ContactAPI.getStrategy", error);
      return null;
    }
  },
};

export default StrategiesAPI;
